package com.appsyde.shared.modules.ticket.domain.model

data class TicketHistoryItem(
    val id: String,
    val direction: String,
    val sentAtMs: Long,
    val summary: String?
)

data class TicketOriginalHistoryItem(
    val id: String,
    val direction: String,
    val sentAtMs: Long,
    val providerMessageId: String?,
    val from: String?,
    val to: String?,
    val subject: String?,
    val mimeType: String?,
    val body: String?,
    val snippet: String?,
    val error: String?
)
